import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { logoutUser } from '../store/features/user';
import { AUTH_TOKEN_STORAGE_KEY } from '../utils/jwt-helper';

/**
 * When another tab clears authToken (logout / 401 handling), localStorage syncs but Redux does not.
 * Keeps in-memory user/cart state aligned so admin and shop tabs do not disagree on login state.
 */
const AuthStorageSync = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    const onStorage = (e) => {
      if (e.key !== AUTH_TOKEN_STORAGE_KEY || e.storageArea !== localStorage) return;
      if (e.newValue === null && e.oldValue != null) {
        dispatch(logoutUser());
      }
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, [dispatch]);
  return null;
};

export default AuthStorageSync;
